/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** BigInt field */
  BigInt: { input: any; output: any; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type AddToPlanInput = {
  entityId: Scalars['String']['input'];
  planName: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  stripeEvent: Scalars['String']['input'];
};

export type AddToPlanResult = {
  __typename?: 'AddToPlanResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddToProductCategoryInput = {
  /** The level of the product category. Must be one of: workspace_id, member_id, evaluation_id, evaluation_version_id. You can use evaluation_id:evaluation_version to send evaluation version level. */
  level?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  productCategoryId?: InputMaybe<Scalars['String']['input']>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  products: Array<ProductCategoryAddInput>;
  vendors: Array<ProductCategoryAddInput>;
};

export type AddressInput = {
  Zip4?: InputMaybe<Scalars['String']['input']>;
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  addressName?: InputMaybe<Scalars['String']['input']>;
  addressPhone?: InputMaybe<Scalars['String']['input']>;
  addressType?: InputMaybe<AddressType>;
  city: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export enum AddressType {
  Billing = 'BILLING',
  Mailing = 'MAILING',
  Other = 'OTHER',
  Shipping = 'SHIPPING'
}

export type Alias = {
  __typename?: 'Alias';
  longDescription: Scalars['String']['output'];
  main: Scalars['Boolean']['output'];
  /** The name of the alias */
  name: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  urlId: Scalars['String']['output'];
};

export type AliasInput = {
  longDescription?: InputMaybe<Scalars['String']['input']>;
  main?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the alias */
  name: Scalars['String']['input'];
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
};

export type AlterEvaluationInput = {
  categories: Array<Scalars['String']['input']>;
  /** category alias selected when creating evaluation */
  categoryAlias?: InputMaybe<Scalars['String']['input']>;
  evaluationVersion?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaData?: InputMaybe<EvaluationMetaDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  setups?: InputMaybe<Array<KeyValueInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  /** use case name alias selected when creating evaluation */
  useCaseAlias?: InputMaybe<Scalars['String']['input']>;
  /** use case name id, or UUID for use case evaluation (evaluation_id) */
  useCaseId?: InputMaybe<Scalars['String']['input']>;
  useCaseVersion?: InputMaybe<Scalars['Int']['input']>;
  useCases: Array<UseCaseInput>;
};

export type Attribute = {
  __typename?: 'Attribute';
  description?: Maybe<Array<Scalars['String']['output']>>;
  key: Scalars['String']['output'];
  modDate: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AttributeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  modDate?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type BillingCodeReport = {
  __typename?: 'BillingCodeReport';
  entries: Array<BillingCodeReportEntry>;
  totalCustomers: Scalars['Int']['output'];
  totalEvaluations: Scalars['Int']['output'];
  totalSharedUsers: Scalars['Int']['output'];
  totalWorkspaces: Scalars['Int']['output'];
};

export type BillingCodeReportEntry = {
  __typename?: 'BillingCodeReportEntry';
  billingCode: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  evaluationCount: Scalars['Int']['output'];
  parentOrganizationName?: Maybe<Scalars['String']['output']>;
  parentWorkspaceName?: Maybe<Scalars['String']['output']>;
  sharedUserCount: Scalars['Int']['output'];
  workspaceCount: Scalars['Int']['output'];
};

export type BindRef = {
  __typename?: 'BindRef';
  bind: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type BindRefHolder = {
  __typename?: 'BindRefHolder';
  /** The bindrefs for the evaluation context. in type:bind_refs format. */
  bindRefs: Scalars['JSON']['output'];
};

export type Carousel = {
  __typename?: 'Carousel';
  cards: Array<CarouselCard>;
  heading: Scalars['String']['output'];
  subHeading: Scalars['String']['output'];
};

export type CarouselCard = {
  __typename?: 'CarouselCard';
  action: CarouselCardAction;
  body: Scalars['String']['output'];
  color: Scalars['String']['output'];
  icon?: Maybe<CarouselCardIcon>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CarouselCardAction = CarouselLinkAction;

export enum CarouselCardActionType {
  Link = 'LINK'
}

export enum CarouselCardIcon {
  Document = 'DOCUMENT'
}

export type CarouselLinkAction = {
  __typename?: 'CarouselLinkAction';
  label: Scalars['String']['output'];
  type: CarouselCardActionType;
  url: Scalars['String']['output'];
};

export type ChangeReason = {
  __typename?: 'ChangeReason';
  changeId: Scalars['BigInt']['output'];
  changorId: Scalars['String']['output'];
  changorType: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  reasonBind?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export type ChangeWorkspacePlanResponse = {
  __typename?: 'ChangeWorkspacePlanResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ClientSetup = {
  __typename?: 'ClientSetup';
  /** Menu configurations as JSON. */
  menus?: Maybe<Scalars['JSON']['output']>;
  /** The organization name from the workspace settings. */
  orgName?: Maybe<Scalars['String']['output']>;
  /** Report sections tweaks from resolver_setups.json. This can be configured in workspace settings or loaded from resolver_setups.json based on the workspace's org_name. */
  reportSectionsTweaks?: Maybe<Scalars['JSON']['output']>;
  /** Key-value pairs of remaining UI setup configurations. */
  setups: Array<KeyValue>;
  /** Table name mappings from resolver_setups.json. Maps display names to internal table keys. Example for default: {'Features': 'feature', 'Dimensions': 'dimension', 'Requirements': 'requirement', 'Products': 'product'}. Example for PwC: {'L1 (Feature Area)': 'l1', 'L2 (Feature Set)': 'l2', 'L3 (Individual Feature)': 'l3', 'Products': 'product'}. This mapping is client-specific and loaded from resolver_setups.json based on the workspace's org_name. */
  tables?: Maybe<Scalars['JSON']['output']>;
  /** Tab configurations as JSON. */
  tabs?: Maybe<Scalars['JSON']['output']>;
};

export type Collaborator = {
  __typename?: 'Collaborator';
  allowPermissions?: Maybe<Array<Scalars['String']['output']>>;
  avatar?: Maybe<Scalars['String']['output']>;
  connectedToId?: Maybe<Scalars['UUID']['output']>;
  denyPermissions?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<CollaboratorStatus>;
};

export enum CollaboratorStatus {
  Accepted = 'ACCEPTED',
  NotInvited = 'NOT_INVITED',
  Pending = 'PENDING',
  Removed = 'REMOVED'
}

export type ConvertUserInput = {
  fromId: Scalars['String']['input'];
  toRegisterId: Scalars['String']['input'];
};

export type CreateEvaluationResponse = {
  __typename?: 'CreateEvaluationResponse';
  evaluation: Evaluation;
  sectionName?: Maybe<Scalars['String']['output']>;
};

export type CreateEvaluationSimpleResponse = {
  __typename?: 'CreateEvaluationSimpleResponse';
  evaluationVersionId: Scalars['String']['output'];
  sectionName?: Maybe<Scalars['String']['output']>;
};

export type CreateOrganizationInput = {
  backup?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<OrgMetaDataInput>;
  organizationName: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  setup?: InputMaybe<OrganizationSetupInput>;
  setupData?: InputMaybe<OrganizationSetupInput>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlanInput = {
  /** Description of the plan */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Additional metadata for the plan */
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  /** Name of the plan (e.g., 'Free', 'Essentials', 'Team') */
  planName: Scalars['String']['input'];
  /** Type of plan (e.g., 'workspace', 'evaluation') */
  planType?: InputMaybe<Scalars['String']['input']>;
  /** List of policy statements for the plan */
  policyStatements?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Stripe price ID for the plan */
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlanResponse = {
  __typename?: 'CreatePlanResponse';
  message: Scalars['String']['output'];
  planId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateUserInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  source?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkspaceInput = {
  backup?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<WorkspaceMetaDataInput>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  setupData?: InputMaybe<WorkspaceSetupInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  workspaceName: Scalars['String']['input'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  carousel?: Maybe<Carousel>;
  evaluationIds?: Maybe<Array<Scalars['String']['output']>>;
  evaluations: Array<DashboardEvaluation>;
  id: Scalars['ID']['output'];
  owner?: Maybe<User>;
  workspace?: Maybe<WorkspaceSummary>;
};

export type DashboardEvaluation = {
  __typename?: 'DashboardEvaluation';
  categories: Array<ProductCategoryDescriptor>;
  collaborators?: Maybe<Array<Collaborator>>;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  evaluationVersions?: Maybe<Array<EvaluationVersionSummary>>;
  hasExperts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  /** Place to put meta data for the evaluation. */
  metaData: MetaData;
  modDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  numberOfVersions?: Maybe<Scalars['Int']['output']>;
  owner: User;
  productId?: Maybe<Scalars['UUID']['output']>;
  setups?: Maybe<Array<KeyValue>>;
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * key = status, value =
   *   archived | open | deleted is one set.  Also
   *   could have key=shared, or key = lock with value locked | unlocked.
   */
  status?: Maybe<Array<KeyValue>>;
  type: EvaluationType;
  /**
   * The version number of the evaluation.
   *   For an evaluation (not version) this is -1.
   */
  versionNumber?: Maybe<Scalars['Int']['output']>;
  workspace?: Maybe<WorkspaceSummary>;
};

export type DimensionUpsertInput = {
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  dimension: OpinionUpsertInput;
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  evaluationVersion?: InputMaybe<Scalars['Int']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};

export type DimensionsUpsertInput = {
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  dimensions: Array<DimensionUpsertInput>;
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  evaluationVersion?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['String']['input'];
  sourceType?: InputMaybe<Scalars['String']['input']>;
};

export type Evaluation = {
  __typename?: 'Evaluation';
  categories: Array<ProductCategoryDescriptor>;
  collaborators?: Maybe<Array<Collaborator>>;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  evaluationVersions?: Maybe<Array<EvaluationVersionSummary>>;
  hasExperts?: Maybe<Scalars['Boolean']['output']>;
  hasQuestions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  /** Place to put meta data for the evaluation. */
  metaData: MetaData;
  modDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  numberOfVersions?: Maybe<Scalars['Int']['output']>;
  owner: User;
  /** Status of evaluation processing: 'processing', 'ready', or 'error' */
  processingStatus?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['UUID']['output']>;
  setups?: Maybe<Array<KeyValue>>;
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * key = status, value =
   *   archived | open | deleted is one set.  Also
   *   could have key=shared, or key = lock with value locked | unlocked.
   */
  status?: Maybe<Array<KeyValue>>;
  type: EvaluationType;
  /**
   * The version number of the evaluation.
   *   For an evaluation (not version) this is -1.
   */
  versionNumber?: Maybe<Scalars['Int']['output']>;
  workspace?: Maybe<Workspace>;
};

/** Excludes a product from an evaluation or workspace.  Can send product_id or product_hd_id. */
export type EvaluationExcludeProductInput = {
  action?: Scalars['String']['input'];
  /** One of evaluation_id, evlauation_version_id, workspace_id, member_id. */
  level: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
};

/** Excludes a vendor from an evaluation or workspace.  Can send vendor_id or vendor_hd_id. */
export type EvaluationExcludeVendorInput = {
  action?: Scalars['String']['input'];
  /** One of evaluation_id, evlauation_version_id, workspace_id, member_id. */
  level: Scalars['ID']['input'];
  vendorId: Scalars['String']['input'];
};

export type EvaluationInput = {
  appliedPlan?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<MetaDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** category alias selected when creating evaluation */
  productCategories?: InputMaybe<Array<ProductCategoryInput>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  setups?: InputMaybe<Array<KeyValueInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** use case name id, or UUID for use case evaluation (evaluation_id) */
  useCases?: InputMaybe<Array<UseCaseInput>>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type EvaluationInvite = {
  __typename?: 'EvaluationInvite';
  action: Scalars['String']['output'];
  inviteToId: Scalars['String']['output'];
  inviteeAuth0Id?: Maybe<Scalars['String']['output']>;
  inviteeEmail?: Maybe<Scalars['String']['output']>;
  inviteeId?: Maybe<Scalars['String']['output']>;
  invitorAuth0Id?: Maybe<Scalars['String']['output']>;
  invitorId: Scalars['String']['output'];
  roles: Scalars['String']['output'];
};

export type EvaluationInviteInput = {
  action?: Scalars['String']['input'];
  inviteToId: Scalars['String']['input'];
  inviteeEmail?: InputMaybe<Scalars['String']['input']>;
  inviteeId?: InputMaybe<Scalars['String']['input']>;
  invitorId?: InputMaybe<Scalars['String']['input']>;
  roles?: Scalars['String']['input'];
};

export type EvaluationInviteInputs = {
  invites: Array<EvaluationInviteInput>;
};

/**
 * Lock an evaluation or evaluation_version.
 * This will prevent other users from
 * updating the evaluation until it is unlocked.
 */
export type EvaluationLockInput = {
  creatorId: Scalars['String']['input'];
  /** The evaluation id to lock.  Can be either evaluation_id or evaluation_version_id. */
  evaluationId: Scalars['String']['input'];
  type?: Scalars['String']['input'];
};

export type EvaluationMetaData = {
  __typename?: 'EvaluationMetaData';
  images?: Maybe<Array<Scalars['String']['output']>>;
  opinionHds: Array<Scalars['String']['output']>;
  /** The plan count for the evaluation. {number_of_shared_users: int, number_of_changes: int} */
  planCount: Scalars['JSON']['output'];
  /** The product categories specified when creating. {name: ProductCategoryDescriptor]} */
  productCategories: Array<ProductCategoryDescriptor>;
  productsHds: Array<Scalars['String']['output']>;
  /** The use cases specified when creating. alias: id */
  useCases: Array<UseCaseDescription>;
};

export type EvaluationMetaDataInput = {
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  opinionHds?: InputMaybe<Array<Scalars['String']['input']>>;
  productsHds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum EvaluationType {
  Alternative = 'ALTERNATIVE',
  Cost = 'COST',
  CostReport = 'COST_REPORT',
  Recommendation = 'RECOMMENDATION',
  Unknown = 'UNKNOWN',
  Validation = 'VALIDATION'
}

export type EvaluationVersionInput = {
  /** Use this evaluation id to create a new version. */
  evaluationId?: InputMaybe<Scalars['ID']['input']>;
  /** If filledit will copy from that version if it.  Otherwise create as initial. */
  evaluationVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type EvaluationVersionSummary = {
  __typename?: 'EvaluationVersionSummary';
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  evaluationId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  modDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type Expert = {
  __typename?: 'Expert';
  info: ExpertInfo;
  /** The unique name of the use case used for lookup. */
  memberId: Scalars['UUID']['output'];
  productCategories: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ExpertInfo = {
  __typename?: 'ExpertInfo';
  attributes?: Maybe<Array<Attribute>>;
  bioLong?: Maybe<Scalars['String']['output']>;
  bioShort?: Maybe<Scalars['String']['output']>;
  byline?: Maybe<Scalars['String']['output']>;
  calendarLink?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  designations?: Maybe<Array<Scalars['String']['output']>>;
  expertEmail: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  messageLink?: Maybe<Array<Scalars['String']['output']>>;
  productCategories?: Maybe<Array<Scalars['String']['output']>>;
  rate?: Maybe<Array<Scalars['String']['output']>>;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ExpertInfoInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  bioLong?: InputMaybe<Scalars['String']['input']>;
  bioShort?: InputMaybe<Scalars['String']['input']>;
  byline?: InputMaybe<Scalars['String']['input']>;
  calendarLink?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designations?: InputMaybe<Array<Scalars['String']['input']>>;
  expertEmail: Scalars['String']['input'];
  expertMemberId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  productCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  rate?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Fact = {
  __typename?: 'Fact';
  attributes: Array<Attribute>;
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  links: Array<Link>;
  modDate: Scalars['String']['output'];
  notes: Array<Note>;
  type: Scalars['String']['output'];
};

export type FactInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  links?: InputMaybe<Array<LinkInput>>;
  modDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Array<NoteInput>>;
  type: Scalars['String']['input'];
};

export type Flag = {
  __typename?: 'Flag';
  name: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type FlagInput = {
  name: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type Graphic = {
  __typename?: 'Graphic';
  description?: Maybe<Scalars['String']['output']>;
  displays?: Maybe<Array<Scalars['String']['output']>>;
  modDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['UUID']['output']>;
  primary: Scalars['Boolean']['output'];
  resolution?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type GraphicInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type GroupDescriptor = {
  __typename?: 'GroupDescriptor';
  description?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type HeartbeatResponse = {
  __typename?: 'HeartbeatResponse';
  memberId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type KeyValue = {
  __typename?: 'KeyValue';
  id?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type KeyValueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Link = {
  __typename?: 'Link';
  displays?: Maybe<Array<Scalars['String']['output']>>;
  modDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type LinkInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displays?: InputMaybe<Array<Scalars['String']['input']>>;
  lastUpd?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  primary: Scalars['Boolean']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type MetaData = {
  __typename?: 'MetaData';
  evaluationMetadata: EvaluationMetaData;
  useCase?: Maybe<UseCaseMetaDataDetail>;
};

export type MetaDataInput = {
  evaluationMetadata?: InputMaybe<EvaluationMetaDataInput>;
  useCase?: InputMaybe<UseCaseMetaDataInput>;
  useCases?: InputMaybe<UseCasesMetaDataInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addEvaluationTag: Scalars['Boolean']['output'];
  addMemberToTeam: User;
  addOrganization: User;
  /** Add a product category to the system. */
  addProductCategory: ProductCategory;
  addTeam: User;
  addToPlan: AddToPlanResult;
  /** Adds a product or vendor to a product category. */
  addToProductCategory: Scalars['Boolean']['output'];
  addUser: User;
  addWorkspaceTag: Scalars['Boolean']['output'];
  alterEvaluation?: Maybe<Scalars['Void']['output']>;
  changeDashboard: Dashboard;
  changeEvaluationOwner: Evaluation;
  changeEvaluationStatus: Scalars['Boolean']['output'];
  changeEvaluationVersionStatus: Scalars['Boolean']['output'];
  changeWorkspacePlan: ChangeWorkspacePlanResponse;
  completeInviteToEvaluation: EvaluationInvite;
  completeInviteToOrganization: OrganizationMember;
  completeInviteToWorkspace: WorkspaceInvite;
  convertUserToRegisteredUser: User;
  createEvaluation: CreateEvaluationSimpleResponse;
  /**
   * Create a new evaluation.  This will create a new
   *   evaluation with a single version from scratch.  This version is
   *   based on the initial setup of the evaluation.
   */
  createEvaluationVersion: CreateEvaluationResponse;
  createOrganization: Organization;
  createPlan: CreatePlanResponse;
  createUseCase: Evaluation;
  createWorkspace: Workspace;
  deleteDimension: Scalars['Boolean']['output'];
  deleteEvaluation: Scalars['Boolean']['output'];
  deleteFeature: Scalars['Boolean']['output'];
  deleteRequirement: Scalars['Boolean']['output'];
  /**
   * Exclude a product from an evaluation.
   *   This will cause a product not to be used when producing
   *   reports.  It will not remove the product from the evaluation
   *   in terms of lists of products or other data.  In order to remove
   *   the product completely from being available to the evaluation
   *   use the delete product mutation instead.
   */
  excludeProduct: Scalars['Boolean']['output'];
  /**
   * Exclude a vendor from an evaluation.
   *   This will cause a product not to be used when producing
   *   reports.  It will not remove the product from the evaluation
   *   in terms of lists of vendors or other data.  In order to remove
   *   the product completely from being available to the evaluation
   *   use the delete product mutation instead.
   */
  excludeVendor: Scalars['Boolean']['output'];
  insertOpinion: Refid;
  insertOpinions: Array<Opinion>;
  insertProduct: Product;
  insertProductHd: ProductHd;
  insertProducts: Array<Product>;
  insertProductsHd: Array<ProductHd>;
  insertVendor: Vendor;
  insertVendorHd: VendorHd;
  insertVendors: Array<Vendor>;
  insertVendorsHd: Array<VendorHd>;
  inviteMemberToOrganization: OrganizationMember;
  inviteMemberToWorkspace: WorkspaceInvite;
  inviteMembersToWorkspace: Array<WorkspaceInvite>;
  lockEvaluation: Evaluation;
  overridePlanPolicy: OverridePlanPolicyResponse;
  processInviteToEvaluation: EvaluationInvite;
  processInviteToEvaluations: Array<EvaluationInvite>;
  /** Process an Uploadcare file and store it in S3 */
  processUploadcareFile: Scalars['String']['output'];
  productCategoryExpertInput: Expert;
  purchasePlan: PlanPurchaseSession;
  /** Record a heartbeat to track dashboard presence. Should be called every 30 seconds while user is on dashboard or evaluation. Email and name are optional but recommended to avoid lookups. Evaluation ID should be provided when user is viewing an evaluation. */
  recordDashboardHeartbeat: HeartbeatResponse;
  /** Record dashboard load end event (when dashboard finishes rendering). */
  recordDashboardLoadEnd: PerformanceMetricsResponse;
  /** Record dashboard load start event (when dashboard GraphQL query is called). */
  recordDashboardLoadStart: PerformanceMetricsResponse;
  recordEvaluationCreateEnd: RecordEvaluationCreateEndResponse;
  recordEvaluationCreateStart: RecordEvaluationCreateStartResponse;
  recordEvaluationLoadEnd: RecordEvaluationLoadEndResponse;
  /** Record evaluation load error event (when evaluation load fails). */
  recordEvaluationLoadError: PerformanceMetricsResponse;
  recordEvaluationLoadStart: RecordEvaluationLoadStartResponse;
  removeEvaluationTag: Scalars['Boolean']['output'];
  removeProduct: Scalars['Boolean']['output'];
  removeWorkspaceTag: Scalars['Boolean']['output'];
  /** Cause a reset password email to be sent. */
  sendResetPasswordEmail: Scalars['Boolean']['output'];
  /**
   * Store an image path for an evaluation.
   *   Puts evaluation image path in metadata.
   *   This is used to store the image path for the evaluation.
   */
  storeImagePath: Scalars['Boolean']['output'];
  /** Bootstrap Auth0 cache from S3. Requires taloflow:admin scope. */
  triggerAuth0Bootstrap: Scalars['String']['output'];
  /** Trigger Auth0 bulk user export. Requires taloflow:admin scope. */
  triggerAuth0BulkExport: Scalars['String']['output'];
  /** Map missing database users to bootstrap users and cache them. Only works in dev/staging. Requires taloflow:admin scope. */
  triggerMapMissingUsers: Scalars['String']['output'];
  /**
   * Update an evaluation with
   *   optional compression. Updates evaluation
   *   with latest data from database.
   *   Note: **This does not force a UI update**
   */
  updateEvaluation: Scalars['JSON']['output'];
  updateEvaluationName: Scalars['Boolean']['output'];
  /**
   * Run the first time update for an evaluation.
   *   This will update the evaluation with the latest data from the
   *   database.
   *
   *   NOTE:  This is an internal call.
   */
  updateFirstTime: Scalars['Boolean']['output'];
  updateOpinion: Refid;
  updatePassword: Scalars['Boolean']['output'];
  updateProduct: Product;
  updateProductCategory: ProductCategory;
  updateProductHd: ProductHd;
  updateProfile: UserProfile;
  updateVendor: Vendor;
  updateVendorHd: VendorHd;
  updateWorkspace: Workspace;
  upsertChangeReason: ChangeReason;
  upsertDimension: Refid;
  upsertDimensions: Array<Refid>;
  upsertExpert: Expert;
  upsertFeature: Refid;
  upsertFeatures: Array<Refid>;
  upsertOpinion: Refid;
  upsertProduct: Product;
  /** Upserts a product category. */
  upsertProductCategory: ProductCategory;
  /** Adds or deletes a product category alias. */
  upsertProductCategoryAlias: ProductCategory;
  upsertProductHd: ProductHd;
  upsertProducts: Array<Product>;
  upsertProductsHd: Array<ProductHd>;
  upsertRequirement: Refid;
  upsertRequirements: Array<Refid>;
  upsertVendor: Vendor;
  upsertVendorHd: VendorHd;
};


export type MutationAddEvaluationTagArgs = {
  default?: Scalars['Boolean']['input'];
  description?: Scalars['String']['input'];
  evaluationId: Scalars['String']['input'];
  omit?: Scalars['Boolean']['input'];
  tagName: Scalars['String']['input'];
};


export type MutationAddMemberToTeamArgs = {
  input: CreateUserInput;
};


export type MutationAddOrganizationArgs = {
  input: CreateUserInput;
};


export type MutationAddProductCategoryArgs = {
  input: ProductCategoryInput;
};


export type MutationAddTeamArgs = {
  input: CreateUserInput;
};


export type MutationAddToPlanArgs = {
  input: AddToPlanInput;
};


export type MutationAddToProductCategoryArgs = {
  input: AddToProductCategoryInput;
};


export type MutationAddUserArgs = {
  input: CreateUserInput;
};


export type MutationAddWorkspaceTagArgs = {
  default?: Scalars['Boolean']['input'];
  description?: Scalars['String']['input'];
  omit?: Scalars['Boolean']['input'];
  tagName: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationAlterEvaluationArgs = {
  input: AlterEvaluationInput;
};


export type MutationChangeDashboardArgs = {
  numberPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeEvaluationOwnerArgs = {
  input: EvaluationInput;
};


export type MutationChangeEvaluationStatusArgs = {
  evaluationId: Scalars['String']['input'];
  newStatus: Scalars['String']['input'];
};


export type MutationChangeEvaluationVersionStatusArgs = {
  evaluationId: Scalars['String']['input'];
  newStatus: Scalars['String']['input'];
};


export type MutationChangeWorkspacePlanArgs = {
  newPlanName: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationCompleteInviteToEvaluationArgs = {
  input: EvaluationInviteInput;
};


export type MutationCompleteInviteToOrganizationArgs = {
  input: OrganizationInviteInput;
};


export type MutationCompleteInviteToWorkspaceArgs = {
  input: WorkspaceInviteInput;
};


export type MutationConvertUserToRegisteredUserArgs = {
  input: ConvertUserInput;
};


export type MutationCreateEvaluationArgs = {
  input: EvaluationInput;
};


export type MutationCreateEvaluationVersionArgs = {
  input: EvaluationVersionInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};


export type MutationCreateUseCaseArgs = {
  input: UseCaseInput;
};


export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


export type MutationDeleteDimensionArgs = {
  level: Scalars['ID']['input'];
  refId: Scalars['ID']['input'];
};


export type MutationDeleteEvaluationArgs = {
  evaluationId: Scalars['String']['input'];
};


export type MutationDeleteFeatureArgs = {
  level: Scalars['ID']['input'];
  refId: Scalars['ID']['input'];
};


export type MutationDeleteRequirementArgs = {
  level: Scalars['ID']['input'];
  refId: Scalars['ID']['input'];
};


export type MutationExcludeProductArgs = {
  input: EvaluationExcludeProductInput;
};


export type MutationExcludeVendorArgs = {
  input: EvaluationExcludeVendorInput;
};


export type MutationInsertOpinionArgs = {
  input: OpinionUpsertInput;
};


export type MutationInsertOpinionsArgs = {
  input: OpinionsUpsertRequest;
};


export type MutationInsertProductArgs = {
  input: ProductInput;
};


export type MutationInsertProductHdArgs = {
  input: ProductHdInput;
};


export type MutationInsertProductsArgs = {
  input: ProductsInput;
};


export type MutationInsertProductsHdArgs = {
  input: ProductHdsInput;
};


export type MutationInsertVendorArgs = {
  input: VendorInput;
};


export type MutationInsertVendorHdArgs = {
  input: VendorHdInput;
};


export type MutationInsertVendorsArgs = {
  input: VendorsInput;
};


export type MutationInsertVendorsHdArgs = {
  input: VendorHdsInput;
};


export type MutationInviteMemberToOrganizationArgs = {
  input: OrganizationInviteInput;
};


export type MutationInviteMemberToWorkspaceArgs = {
  input: WorkspaceInviteInput;
};


export type MutationInviteMembersToWorkspaceArgs = {
  input: WorkspaceInviteInputs;
};


export type MutationLockEvaluationArgs = {
  input: EvaluationLockInput;
};


export type MutationOverridePlanPolicyArgs = {
  input: OverridePlanPolicyInput;
};


export type MutationProcessInviteToEvaluationArgs = {
  input: EvaluationInviteInput;
};


export type MutationProcessInviteToEvaluationsArgs = {
  input: EvaluationInviteInputs;
};


export type MutationProcessUploadcareFileArgs = {
  fileInput: UploadcareFileInput;
};


export type MutationProductCategoryExpertInputArgs = {
  input: ProductCategoryExpertsInput;
};


export type MutationPurchasePlanArgs = {
  input: PurchasePlanInput;
};


export type MutationRecordDashboardHeartbeatArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordDashboardLoadEndArgs = {
  memberId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordDashboardLoadStartArgs = {
  memberId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordEvaluationCreateEndArgs = {
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};


export type MutationRecordEvaluationCreateStartArgs = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordEvaluationLoadEndArgs = {
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  frontendGraphqlTime?: InputMaybe<Scalars['Float']['input']>;
  sessionId: Scalars['String']['input'];
};


export type MutationRecordEvaluationLoadErrorArgs = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  evaluationId: Scalars['String']['input'];
};


export type MutationRecordEvaluationLoadStartArgs = {
  evaluationId: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveEvaluationTagArgs = {
  evaluationId: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};


export type MutationRemoveProductArgs = {
  level: Scalars['UUID']['input'];
  productHdId: Scalars['UUID']['input'];
};


export type MutationRemoveWorkspaceTagArgs = {
  tagName: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationSendResetPasswordEmailArgs = {
  memberId: Scalars['String']['input'];
};


export type MutationStoreImagePathArgs = {
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerAuth0BootstrapArgs = {
  env?: InputMaybe<Scalars['String']['input']>;
  onlyMissing?: Scalars['Boolean']['input'];
};


export type MutationTriggerAuth0BulkExportArgs = {
  env?: InputMaybe<Scalars['String']['input']>;
  saveLocal?: Scalars['Boolean']['input'];
};


export type MutationTriggerMapMissingUsersArgs = {
  dryRun?: Scalars['Boolean']['input'];
  env?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEvaluationArgs = {
  compress?: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEvaluationNameArgs = {
  evaluationId: Scalars['String']['input'];
  evaluationVersion: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateFirstTimeArgs = {
  evaluationId: Scalars['String']['input'];
};


export type MutationUpdateOpinionArgs = {
  input: OpinionUpsertInput;
};


export type MutationUpdateProductArgs = {
  input: ProductInput;
};


export type MutationUpdateProductCategoryArgs = {
  input: ProductCategoryInput;
};


export type MutationUpdateProductHdArgs = {
  input: ProductHdInput;
};


export type MutationUpdateProfileArgs = {
  profile: UserDataInput;
};


export type MutationUpdateVendorArgs = {
  input: VendorInput;
};


export type MutationUpdateVendorHdArgs = {
  input: VendorHdInput;
};


export type MutationUpdateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


export type MutationUpsertChangeReasonArgs = {
  input: UpsertChangeReasonInput;
};


export type MutationUpsertDimensionArgs = {
  input: DimensionUpsertInput;
};


export type MutationUpsertDimensionsArgs = {
  input: DimensionsUpsertInput;
};


export type MutationUpsertExpertArgs = {
  input: ExpertInfoInput;
};


export type MutationUpsertFeatureArgs = {
  input: ProductFeatureUpsertInput;
};


export type MutationUpsertFeaturesArgs = {
  input: ProductFeaturesUpsertInput;
};


export type MutationUpsertOpinionArgs = {
  input: OpinionUpsertInput;
};


export type MutationUpsertProductArgs = {
  input: ProductInput;
};


export type MutationUpsertProductCategoryArgs = {
  input: ProductCategoryInput;
};


export type MutationUpsertProductCategoryAliasArgs = {
  input: ProductCategoryAliasesInput;
};


export type MutationUpsertProductHdArgs = {
  input: ProductHdInput;
};


export type MutationUpsertProductsArgs = {
  input: ProductsInput;
};


export type MutationUpsertProductsHdArgs = {
  input: ProductHdsInput;
};


export type MutationUpsertRequirementArgs = {
  input: RequirementUpsertInput;
};


export type MutationUpsertRequirementsArgs = {
  input: RequirementsUpsertInput;
};


export type MutationUpsertVendorArgs = {
  input: VendorInput;
};


export type MutationUpsertVendorHdArgs = {
  input: VendorHdInput;
};

export type Note = {
  __typename?: 'Note';
  creatorId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modDate: Scalars['String']['output'];
  note: Scalars['String']['output'];
  noteType: Scalars['String']['output'];
};

export type NoteInput = {
  creatorId: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  modDate?: Scalars['DateTime']['input'];
  note: Scalars['String']['input'];
  noteType: Scalars['String']['input'];
};

export type Opinion = {
  __typename?: 'Opinion';
  id: Scalars['Int']['output'];
};

export type OpinionResultUpsertInput = {
  classification?: InputMaybe<Scalars['String']['input']>;
  /** Either evaluation_id or evaluation_version_id */
  connectedToId?: InputMaybe<Scalars['UUID']['input']>;
  createDate?: InputMaybe<Scalars['String']['input']>;
  isEvaluated?: InputMaybe<Scalars['Boolean']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<MetaDataInput>;
  modDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opinionId?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type OpinionUpsertInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  classification?: InputMaybe<Scalars['String']['input']>;
  /** Optional way to associate with vendor. */
  commonName?: InputMaybe<Scalars['String']['input']>;
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<FlagInput>>;
  /** For update only. */
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['UUID']['input']>;
  links?: InputMaybe<Array<LinkInput>>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Array<NoteInput>>;
  opinionClass?: InputMaybe<Scalars['String']['input']>;
  opinionHdId?: InputMaybe<Scalars['UUID']['input']>;
  placementFunctions?: InputMaybe<Array<PlacementFunctionInput>>;
  productCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  productHdId?: InputMaybe<Scalars['UUID']['input']>;
  /** Optional way to associate with product. */
  productName?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  subclass?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vendorHdId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OpinionsUpsertRequest = {
  opinions: Array<OpinionUpsertInput>;
};

export type OrgMetaDataInput = {
  commonName: Scalars['String']['input'];
  orgType?: OrganizationType;
  otherMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
};

export type Organization = {
  __typename?: 'Organization';
  commonName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  members: Array<OrganizationMember>;
  name: Scalars['String']['output'];
  parent?: Maybe<Organization>;
  parentId?: Maybe<Scalars['String']['output']>;
  workspaces?: Maybe<Array<OrganizationMember>>;
};

/** Input to use to invite a member to an organization. */
export type OrganizationInviteInput = {
  action?: Scalars['String']['input'];
  inviteToId: Scalars['String']['input'];
  inviteeEmail?: InputMaybe<Scalars['String']['input']>;
  inviteeId?: InputMaybe<Scalars['String']['input']>;
  invitorId?: InputMaybe<Scalars['String']['input']>;
  roles?: Scalars['String']['input'];
};

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  inviteStatus: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  user: User;
};

export type OrganizationSetupInput = {
  addresses?: InputMaybe<Array<AddressInput>>;
  commonName: Scalars['String']['input'];
  defaultMemberPolicy?: InputMaybe<Scalars['String']['input']>;
  defaultPlanPolicy?: InputMaybe<Scalars['String']['input']>;
  defaultWorkspacePolicy?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  orgType?: OrganizationType;
  otherSetup?: InputMaybe<Scalars['JSON']['input']>;
};

export enum OrganizationType {
  Enterprise = 'ENTERPRISE',
  Individual = 'INDIVIDUAL',
  Smb = 'SMB',
  Taloflow = 'TALOFLOW'
}

export type OverridePlanPolicyInput = {
  planId: Scalars['String']['input'];
  policyOverrides: PolicyOverridesInput;
  workspaceId: Scalars['String']['input'];
};

export type OverridePlanPolicyResponse = {
  __typename?: 'OverridePlanPolicyResponse';
  groupDetailId?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PerformanceMetricsResponse = {
  __typename?: 'PerformanceMetricsResponse';
  duration?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PlacementFunctionInput = {
  function: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Plan = {
  __typename?: 'Plan';
  active: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  expires: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  metaData: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  planAvailability?: Maybe<PlanAvailability>;
  price: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type PlanAvailability = {
  __typename?: 'PlanAvailability';
  available: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  plan: Plan;
  unit: Scalars['String']['output'];
  used: Scalars['Int']['output'];
};

export type PlanPurchaseSession = {
  __typename?: 'PlanPurchaseSession';
  sessionId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PolicyOverridesInput = {
  additions?: InputMaybe<Array<PolicyStatementInput>>;
  overrides?: InputMaybe<Array<PolicyStatementInput>>;
};

export type PolicyStatementInput = {
  actions: Array<Scalars['String']['input']>;
  condition?: InputMaybe<Scalars['JSON']['input']>;
  effect: Scalars['String']['input'];
  principals?: InputMaybe<Array<Scalars['String']['input']>>;
  resources?: InputMaybe<Array<Scalars['String']['input']>>;
  sid: Scalars['String']['input'];
  type?: InputMaybe<PolicyStatementTypeEnum>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum PolicyStatementTypeEnum {
  Boundry = 'BOUNDRY',
  Permission = 'PERMISSION'
}

/** A product in the catalog used to return the call to the UI. Full version. */
export type Product = {
  __typename?: 'Product';
  attributes?: Maybe<Array<Attribute>>;
  createDate: Scalars['DateTime']['output'];
  curationLevel: Scalars['Int']['output'];
  facts?: Maybe<Array<Fact>>;
  flags?: Maybe<Array<Flag>>;
  graphics?: Maybe<Array<Graphic>>;
  id: Scalars['UUID']['output'];
  links?: Maybe<Array<Link>>;
  modDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Array<Note>>;
  pricingRules?: Maybe<Array<Scalars['String']['output']>>;
  productHdId: Scalars['UUID']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  bind: Scalars['String']['output'];
  createDate: Scalars['DateTime']['output'];
  experts: Array<Expert>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  keys: Array<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  lastReviewBy?: Maybe<Scalars['String']['output']>;
  lastReviewDate?: Maybe<Scalars['String']['output']>;
  level: Scalars['UUID']['output'];
  metaData?: Maybe<ProductCategoryMetaData>;
  modDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  subtext?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  useCases: Array<UseCaseDescription>;
  value: Scalars['String']['output'];
};

export type ProductCategoryAddInput = {
  level?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  productCategoryName: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  vendorCommonName: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Used to upsert a product category alias. */
export type ProductCategoryAliasInput = {
  /** If the alias is active or not.  Set to false to remove. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['ID']['input']>;
  longDescription: Scalars['String']['input'];
  main?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  productCategoryId?: InputMaybe<Scalars['String']['input']>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
};

export type ProductCategoryAliasesInput = {
  aliases: Array<ProductCategoryAliasInput>;
  /** The level of the product category. Must be one of: workspace_id, member_id, evaluation_id, evaluation_version_id. You can use evaluation_id:evaluation_version to send evaluation version level. */
  level?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['String']['input'];
  productCategoryId?: InputMaybe<Scalars['String']['input']>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
};

/** A product category descriptor.  This is a short hand for a single product category alias. */
export type ProductCategoryDescriptor = {
  __typename?: 'ProductCategoryDescriptor';
  /** The active status of the product category. */
  activeStatus: Scalars['String']['output'];
  /** The curation level of the product category. */
  curationLevel: Scalars['Int']['output'];
  /** The id of the product category. */
  id: Scalars['String']['output'];
  /** The last review date of the product category. */
  lastReviewDate: Scalars['DateTime']['output'];
  /** The level of the product category. */
  level: Scalars['UUID']['output'];
  /** The long description of the product category. */
  longDescription: Scalars['String']['output'];
  /** The name of the product category. */
  name: Scalars['String']['output'];
  /** The short description of the product category. */
  shortDescription: Scalars['String']['output'];
  /** The url id of the product category. */
  urlId: Scalars['String']['output'];
};

export type ProductCategoryExpertsInput = {
  calendarLink?: InputMaybe<Array<Scalars['String']['input']>>;
  expertEmail: Scalars['String']['input'];
  expertMemberId?: InputMaybe<Scalars['String']['input']>;
  productCategories: Array<Scalars['String']['input']>;
  rate?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Used for creating or updating a product category.  Note use add_child and change_status routes for child and status changes. */
export type ProductCategoryInput = {
  /** Backup of the category. */
  backup?: InputMaybe<Scalars['JSON']['input']>;
  /** Member id that will be creator_id */
  creatorId?: InputMaybe<Scalars['String']['input']>;
  executiveSummary?: InputMaybe<Scalars['String']['input']>;
  /** List of expert ids */
  experts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** For updates. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  keyed?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Uses system user if system category add. */
  level?: InputMaybe<Scalars['UUID']['input']>;
  /** description above will be inserted into meta data. */
  metaData?: InputMaybe<ProductCategoryMetaDataInput>;
  /** Just the name of category alone.  No member_id or evaluation_id */
  name: Scalars['String']['input'];
  sourceType?: SourceType;
};

export type ProductCategoryMetaData = {
  __typename?: 'ProductCategoryMetaData';
  alias?: Maybe<Array<Alias>>;
  curationLevel?: Maybe<Scalars['Int']['output']>;
  hasExperts?: Maybe<Scalars['Boolean']['output']>;
  hasQuestions?: Maybe<Scalars['Boolean']['output']>;
  lastReviewBy?: Maybe<Scalars['String']['output']>;
  lastReviewDate?: Maybe<Scalars['String']['output']>;
  sourceHeader?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<SourceType>;
  urlId?: Maybe<Scalars['String']['output']>;
  webSearchKeywords?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProductCategoryMetaDataInput = {
  alias?: InputMaybe<Scalars['JSON']['input']>;
  /** 0-10 curation level defaults to 0 */
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  hasExperts?: InputMaybe<Scalars['Boolean']['input']>;
  lastReviewBy?: InputMaybe<Scalars['String']['input']>;
  lastReviewDate?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  sourceHeader?: InputMaybe<Scalars['String']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  webSearchKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductFeatureUpsertInput = {
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  dimensions?: InputMaybe<Array<OpinionUpsertInput>>;
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  evaluationVersion?: InputMaybe<Scalars['Int']['input']>;
  /** For update only. */
  id?: InputMaybe<Scalars['Int']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  opinion: OpinionUpsertInput;
  productHdId?: InputMaybe<Scalars['String']['input']>;
  /** Optional way to associate with product. */
  productName?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  /** Optional way to associate with vendor. */
  vendorCommonName?: InputMaybe<Scalars['String']['input']>;
  vendorHdId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductFeaturesUpsertInput = {
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  evaluationVersion?: InputMaybe<Scalars['Int']['input']>;
  features: Array<ProductFeatureUpsertInput>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Optional way to associate with product. */
  productName?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  /** Optional way to associate with vendor. */
  vendorCommonName?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

/** A product in the catalog used to return the call to the UI.  Full version. */
export type ProductHd = {
  __typename?: 'ProductHd';
  createDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  level: Scalars['UUID']['output'];
  metaData: Scalars['JSON']['output'];
  modDate: Scalars['DateTime']['output'];
  productCn: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  vendorHdId: Scalars['UUID']['output'];
};

export type ProductHdInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  createDate?: InputMaybe<Scalars['DateTime']['input']>;
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  facts?: InputMaybe<Array<FactInput>>;
  flags?: InputMaybe<Array<FlagInput>>;
  graphics?: InputMaybe<Array<GraphicInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** The level of the product. Must be one of: workspace_id, member_id, evaluation_id, evaluation_version_id. You can use evaluation_id:evaluation_version to send evaluation version level. */
  level: Scalars['ID']['input'];
  links?: InputMaybe<Array<LinkInput>>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  modDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Array<NoteInput>>;
  pricingRules?: InputMaybe<Array<Scalars['String']['input']>>;
  recordTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  saveToOrg?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
  sourceType?: InputMaybe<Scalars['String']['input']>;
  vendorCommonName?: InputMaybe<Scalars['String']['input']>;
  vendorHdId?: InputMaybe<Scalars['ID']['input']>;
  vendorName: Scalars['String']['input'];
};

export type ProductHdsInput = {
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['UUID']['input']>;
  productHds: Array<ProductHdInput>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};

export type ProductInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  createDate?: InputMaybe<Scalars['DateTime']['input']>;
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  facts?: InputMaybe<Array<FactInput>>;
  flags?: InputMaybe<Array<FlagInput>>;
  graphics?: InputMaybe<Array<GraphicInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** The level of the product. Must be one of: workspace_id, member_id, evaluation_id, evaluation_version_id. You can use evaluation_id:evaluation_version to send evaluation version level. */
  level: Scalars['ID']['input'];
  links?: InputMaybe<Array<LinkInput>>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  modDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Array<NoteInput>>;
  pricingRules?: InputMaybe<Array<Scalars['String']['input']>>;
  recordTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  saveToOrg?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
  sourceType?: InputMaybe<Scalars['String']['input']>;
  vendorCommonName?: InputMaybe<Scalars['String']['input']>;
  vendorHdId?: InputMaybe<Scalars['ID']['input']>;
  vendorName: Scalars['String']['input'];
  vendorShortName: Scalars['String']['input'];
  vendorUniqueName?: InputMaybe<Scalars['String']['input']>;
};

export type ProductsInput = {
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['UUID']['input']>;
  products: Array<ProductInput>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};

export type PurchasePlanInput = {
  cancelUrl: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  purchaserId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  Service: Service;
  appliedUserId: Scalars['String']['output'];
  canDownloadReport: Scalars['Boolean']['output'];
  /**
   * Given an evaluation id and version returns the
   *   collaborators for the evaluation version.  If no version than
   *   returns the collaborators for the evaluation.
   */
  collaborators: Array<Collaborator>;
  dashboard: Dashboard;
  /**
   * Get an evaluation or version by id..  This will
   *   return a full evaluation header
   *   object which includes the versions.
   */
  evaluation: Evaluation;
  /**
   * Given a slug in evaluation_id:evaluation_version format
   *   returns the evaluation header object (with all versions)
   *   for the evaluation.
   */
  evaluationBySlug: Evaluation;
  /**
   * Given a stripe session id return the evaluation
   *   associated with the session
   */
  evaluationByStripeSession: Evaluation;
  evaluationPlans: Array<Plan>;
  /**
   * Get an evaluation version.  This will
   *   return the evaluation version object
   */
  evaluationVersion: Evaluation;
  /**
   * Given a slug in evaluation_id:evaluation_version format
   *   return the evaluation version object.
   */
  evaluationVersionBySlug: Evaluation;
  getBillingCodeReport: BillingCodeReport;
  /**
   * Get a list of bindrefs of different
   *   types for the evaluation context.
   */
  getBindRefs: BindRefHolder;
  /** Get client setup configuration for a workspace. */
  getClientSetup: ClientSetup;
  /**
   * Given a first product id, second product id and type
   *   returns the comparison table.
   *   Type is dimension, requirement, feature
   */
  getComparisonTable: BindRef;
  getDefaultEvaluationRoles: Array<Scalars['String']['output']>;
  /** Get a link to a spreadsheet with a detailed explanation for dimensions and requirements */
  getDetailSpreadsheet: Scalars['String']['output'];
  /** Get a link to a spreadsheet with a detailed explanation for dimensions and requirements */
  getDetailSpreadsheetBytes: Scalars['String']['output'];
  getDimensions: Array<BindRef>;
  getEvaluationRoles: Array<Scalars['String']['output']>;
  /**
   * Get the tags available for an evaluation.
   *   Returns tags aggregated from workspace hierarchy and evaluation,
   *   with evaluation tags taking precedence over workspace tags.
   */
  getEvaluationTags: Array<Tag>;
  /** Get features for a given level where level is one of the following evaluation_version_id, evaluation_id, workspace_id, None for system. */
  getFeatures: Array<BindRef>;
  getOrganizationMembers: Array<OrganizationMember>;
  /** Return a product graphqlobject from a product id. */
  getProduct: Product;
  /** Return a product graphql object from a product id. */
  getProductBindref: BindRef;
  /** Gets the product categories page.  Graphql representation of the Rest Route. */
  getProductCategoriesPage: Scalars['JSON']['output'];
  /** Gets the product category page.  Graphql representation of the Rest Route. */
  getProductCategoryPage: Scalars['JSON']['output'];
  /** Return a product hd ui object from a product id. */
  getProductHd: ProductHd;
  /** Return a product hd bindref object from a product id. */
  getProductHdBindref: BindRef;
  /** Return a product hd ui object from a product id. */
  getProductHdUi: UiProductHd;
  /** Return a product hd graphql object from a product id. */
  getProductHds: Array<Product>;
  /** Return a product hd bindref object from a product id. */
  getProductHdsBindref: Array<Product>;
  /** Return a product hd ui object from a product id. */
  getProductHdsUi: Array<Product>;
  /** Return a product graphql object from a product id. */
  getProductUi: UiProduct;
  /** Return a list of full graphql products at a level. */
  getProducts: Array<Product>;
  /** Return a list of products bindref objects at a level. */
  getProductsBindref: Array<BindRef>;
  /** Gets the products categories for a given product category. */
  getProductsInProductCategory: Array<ProductCategory>;
  /** Return a list of products UI objects at a level. */
  getProductsUi: Array<UiProduct>;
  getRequirements: Array<BindRef>;
  /** Return a vendor graphqlobject from a vendor id. */
  getVendor: Vendor;
  /** Return a vendor graphql object from a vendor id. */
  getVendorBindref: BindRef;
  /** Return a vendor hd ui object from a vendor id. */
  getVendorHd: VendorHd;
  /** Return a vendor hd bindref object from a vendor id. */
  getVendorHdBindref: BindRef;
  /** Return a vendor hd ui object from a vendor id. */
  getVendorHdUi: UiVendorHd;
  /** Return a vendor hd graphql object from a vendor id. */
  getVendorHds: Array<Vendor>;
  /** Return a vendor hd bindref object from a vendor id. */
  getVendorHdsBindref: Array<Vendor>;
  /** Return a vendor hd ui object from a vendor id. */
  getVendorHdsUi: Array<Vendor>;
  /** Return a vendor graphql object from a vendor id. */
  getVendorUi: UiVendor;
  /** Return a list of full graphql vendors at a level. */
  getVendors: Array<Vendor>;
  /** Return a list of vendors bindref objects at a level. */
  getVendorsBindref: Array<BindRef>;
  /** Return a list of vendors UI objects at a level. */
  getVendorsUi: Array<UiVendor>;
  getWorkspaceMembers: Array<WorkspaceMember>;
  getWorkspacesForMember: Array<Workspace>;
  /**
   * Given an evaluation version, a multi select type and
   *   the parent id returns the bind refs (bound features)
   *   for the multi select type.
   */
  multiSelect: Array<BindRef>;
  planInfo: Plan;
  plans: Array<Plan>;
  /**
   * Gets the product categories
   *   for a given level.
   *   Provides a list.  Level is evaluation_version_id
   *   evaluation_id, workspace, or None
   *   for system level
   */
  productCategories: Array<ProductCategory>;
  /**
   * Gets the product categories
   *   for a given level.
   *   Provides a list.  Level is evaluation_version_id
   *   evaluation_id, workspace, or None
   *   for system level
   */
  productCategoriesBindref: Array<BindRef>;
  /** Given a use case id returns the use case metadata. */
  useCase: UseCaseMetaDataDetail;
  /**
   * Given a product categry returns use cases associated
   *   with the product category.
   */
  useCases: Array<UseCaseMetaDataDetail>;
  user: User;
  workspace: Workspace;
  workspaceNameAndId: Workspace;
};


export type QueryCollaboratorsArgs = {
  evaluationId?: Scalars['ID']['input'];
};


export type QueryDashboardArgs = {
  numberPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEvaluationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEvaluationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryEvaluationByStripeSessionArgs = {
  stripeSession: Scalars['String']['input'];
};


export type QueryEvaluationVersionArgs = {
  id?: Scalars['ID']['input'];
};


export type QueryEvaluationVersionBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetBillingCodeReportArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetBindRefsArgs = {
  bindType?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetClientSetupArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryGetComparisonTableArgs = {
  evaluationId: Scalars['String']['input'];
  firstProductId: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  secondProductId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryGetDetailSpreadsheetArgs = {
  evaluationId: Scalars['ID']['input'];
  output?: Scalars['String']['input'];
};


export type QueryGetDetailSpreadsheetBytesArgs = {
  evaluationId: Scalars['ID']['input'];
  output?: Scalars['String']['input'];
};


export type QueryGetDimensionsArgs = {
  filterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetEvaluationRolesArgs = {
  evaluationId: Scalars['ID']['input'];
  evaluationVersion: Scalars['Int']['input'];
};


export type QueryGetEvaluationTagsArgs = {
  evaluationId: Scalars['ID']['input'];
};


export type QueryGetFeaturesArgs = {
  filterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetOrganizationMembersArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProductBindrefArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProductCategoryPageArgs = {
  productCategoryId: Scalars['ID']['input'];
};


export type QueryGetProductHdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetProductHdBindrefArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetProductHdUiArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetProductHdsArgs = {
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetProductHdsBindrefArgs = {
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetProductHdsUiArgs = {
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetProductUiArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProductsArgs = {
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetProductsBindrefArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetProductsInProductCategoryArgs = {
  productCategoryId: Scalars['ID']['input'];
};


export type QueryGetProductsUiArgs = {
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetRequirementsArgs = {
  filterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetVendorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVendorBindrefArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVendorHdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVendorHdBindrefArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVendorHdUiArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVendorHdsArgs = {
  level?: Scalars['ID']['input'];
};


export type QueryGetVendorHdsBindrefArgs = {
  level?: Scalars['ID']['input'];
};


export type QueryGetVendorHdsUiArgs = {
  level?: Scalars['ID']['input'];
};


export type QueryGetVendorUiArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVendorsArgs = {
  level?: Scalars['ID']['input'];
};


export type QueryGetVendorsBindrefArgs = {
  level?: Scalars['ID']['input'];
};


export type QueryGetVendorsUiArgs = {
  level?: Scalars['ID']['input'];
};


export type QueryGetWorkspaceMembersArgs = {
  workspaceId: Scalars['String']['input'];
};


export type QueryGetWorkspacesForMemberArgs = {
  memberId: Scalars['String']['input'];
};


export type QueryMultiSelectArgs = {
  evaluationId: Scalars['ID']['input'];
  parentId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryProductCategoriesArgs = {
  level?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductCategoriesBindrefArgs = {
  level?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUseCaseArgs = {
  id: Scalars['String']['input'];
};


export type QueryUseCasesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  productCategoryId?: InputMaybe<Scalars['String']['input']>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  useCaseName?: InputMaybe<Scalars['String']['input']>;
  withOther?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserArgs = {
  memberId: Scalars['String']['input'];
};


export type QueryWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkspaceNameAndIdArgs = {
  id: Scalars['ID']['input'];
};

export type RecordEvaluationCreateEndResponse = {
  __typename?: 'RecordEvaluationCreateEndResponse';
  duration?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RecordEvaluationCreateStartResponse = {
  __typename?: 'RecordEvaluationCreateStartResponse';
  message?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RecordEvaluationLoadEndResponse = {
  __typename?: 'RecordEvaluationLoadEndResponse';
  duration?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RecordEvaluationLoadStartResponse = {
  __typename?: 'RecordEvaluationLoadStartResponse';
  message?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Refid = {
  __typename?: 'Refid';
  id: Scalars['String']['output'];
};

export type RequirementUpsertInput = {
  features?: InputMaybe<Array<OpinionUpsertInput>>;
  featuresRemoved?: InputMaybe<Array<OpinionUpsertInput>>;
  opinion: OpinionUpsertInput;
};

export type RequirementsUpsertInput = {
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  evaluationVersion?: InputMaybe<Scalars['Int']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Optional way to associate with product. */
  productName?: InputMaybe<Scalars['String']['input']>;
  requirements: Array<RequirementUpsertInput>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  /** Optional way to associate with vendor. */
  vendorCommonName?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type Service = {
  __typename?: 'Service';
  sdl: Scalars['String']['output'];
};

export enum SourceType {
  Calculated = 'CALCULATED',
  Curated = 'CURATED',
  Llm = 'LLM',
  Other = 'OTHER',
  System = 'SYSTEM',
  User = 'USER'
}

export type Tag = {
  __typename?: 'Tag';
  default: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Product abbreviated data to be use with UI. */
export type UiProduct = {
  __typename?: 'UiProduct';
  curationLevel?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  level?: Maybe<Scalars['UUID']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productCn: Scalars['String']['output'];
  productHd?: Maybe<UiProductHd>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
  sourceType?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<UiVendor>;
};

export type UiProductHd = {
  __typename?: 'UiProductHd';
  id?: Maybe<Scalars['UUID']['output']>;
  level?: Maybe<Scalars['UUID']['output']>;
  productCn: Scalars['String']['output'];
  sourceType?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<UiVendor>;
};

/** Abbreviated Vendor to be use with UI. */
export type UiVendor = {
  __typename?: 'UiVendor';
  hq?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  level?: Maybe<Scalars['UUID']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
  sourceType?: Maybe<Scalars['String']['output']>;
  vendorCn: Scalars['String']['output'];
  vendorHd?: Maybe<UiVendorHd>;
  vendorHdId?: Maybe<Scalars['UUID']['output']>;
  yearEstablished?: Maybe<Scalars['Int']['output']>;
};

export type UiVendorHd = {
  __typename?: 'UiVendorHd';
  curationLevel?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['UUID']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  vendorCn: Scalars['String']['output'];
};

export type UploadcareFileInput = {
  /** The Uploadcare file ID */
  fileId: Scalars['String']['input'];
  /** Name of the file */
  fileName: Scalars['String']['input'];
  /** Type of file - either 'org_logo' or 'rag_doc' */
  fileType: Scalars['String']['input'];
  /** URL of the file */
  fileUrl: Scalars['String']['input'];
  /** Organization ID for storing the file */
  orgId: Scalars['String']['input'];
};

export type UpsertChangeReasonInput = {
  changeId?: InputMaybe<Scalars['BigInt']['input']>;
  evaluationId: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  reasonBind?: InputMaybe<Scalars['String']['input']>;
};

export type UseCaseDescription = {
  __typename?: 'UseCaseDescription';
  aliases: Array<Alias>;
  curationLevel: Scalars['Int']['output'];
  hasExperts: Scalars['Boolean']['output'];
  /** The alias name of the use case in the current context */
  id: Scalars['String']['output'];
  longDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type UseCaseInput = {
  aliases?: InputMaybe<Array<AliasInput>>;
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<MetaDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  opinionResults?: InputMaybe<Array<OpinionResultUpsertInput>>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  setups?: InputMaybe<Array<KeyValueInput>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UseCaseMetaDataDetail = {
  __typename?: 'UseCaseMetaDataDetail';
  aliases: Array<Alias>;
  /** The curation level of the use case */
  curationLevel: Scalars['Int']['output'];
  /** Whether the use case has experts */
  experts?: Maybe<Array<Expert>>;
  /** Whether the use case has experts */
  hasExperts?: Maybe<Scalars['Boolean']['output']>;
  /** The unique name of the use case used for lookup. */
  id: Scalars['String']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  /** The name of the use case */
  name: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** The source type of the use case */
  sourceType: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type UseCaseMetaDataDetailInput = {
  alias?: InputMaybe<Scalars['JSON']['input']>;
  curationLevel: Scalars['Int']['input'];
  hasExperts?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  sourceHeader?: InputMaybe<Scalars['String']['input']>;
  sourceType: Scalars['String']['input'];
};

export type UseCaseMetaDataInput = {
  alias?: InputMaybe<Scalars['JSON']['input']>;
  curationLevel: Scalars['Int']['input'];
  hasExperts?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  sourceHeader?: InputMaybe<Scalars['String']['input']>;
  sourceType: Scalars['String']['input'];
};

export type UseCasesMetaDataInput = {
  useCases?: InputMaybe<Array<UseCaseMetaDataDetailInput>>;
};

export type User = {
  __typename?: 'User';
  auth0Id?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<GroupDescriptor>>;
  memberId: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  settings?: Maybe<Array<Maybe<KeyValue>>>;
};

export type UserDataInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  avatar: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  type: UserType;
};

export enum UserType {
  Admin = 'ADMIN',
  Guest = 'GUEST',
  Registered = 'REGISTERED',
  System = 'SYSTEM'
}

/** Vendor object for return to graphql.  Full object.  Not really used for UI. */
export type Vendor = {
  __typename?: 'Vendor';
  attributes?: Maybe<Array<Attribute>>;
  createDate: Scalars['DateTime']['output'];
  curationLevel: Scalars['Int']['output'];
  facts?: Maybe<Array<Fact>>;
  flags?: Maybe<Array<Flag>>;
  graphics?: Maybe<Array<Graphic>>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  level: Scalars['UUID']['output'];
  links?: Maybe<Array<Link>>;
  longDescription?: Maybe<Scalars['String']['output']>;
  metaData: Scalars['JSON']['output'];
  modDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  pricingRules?: Maybe<Array<Scalars['String']['output']>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  vendorCn?: Maybe<Scalars['String']['output']>;
  vendorHdId?: Maybe<Scalars['UUID']['output']>;
};

/** A vendor in the catalog used to return the call to the UI.  Full version. */
export type VendorHd = {
  __typename?: 'VendorHd';
  createDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  level: Scalars['UUID']['output'];
  metaData: Scalars['JSON']['output'];
  modDate: Scalars['DateTime']['output'];
  sourceType: Scalars['String']['output'];
  vendorCn: Scalars['String']['output'];
};

export type VendorHdInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  commonName?: InputMaybe<Scalars['String']['input']>;
  createDate?: InputMaybe<Scalars['DateTime']['input']>;
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  facts?: InputMaybe<Array<FactInput>>;
  flags?: InputMaybe<Array<FlagInput>>;
  graphics?: InputMaybe<Array<GraphicInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** The level of the vendor. Must be one of: workspace_id, member_id, evaluation_id, evaluation_version_id. You can use evaluation_id:evaluation_version to send evaluation version level. */
  level?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<LinkInput>>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  modDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  pricingRules?: InputMaybe<Array<Scalars['String']['input']>>;
  recordTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  saveToOrg?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
  sourceType?: InputMaybe<Scalars['String']['input']>;
};

export type VendorHdsInput = {
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['UUID']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  vendorHds: Array<VendorHdInput>;
};

export type VendorInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  commonName?: InputMaybe<Scalars['String']['input']>;
  createDate?: InputMaybe<Scalars['DateTime']['input']>;
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  facts?: InputMaybe<Array<FactInput>>;
  flags?: InputMaybe<Array<FlagInput>>;
  graphics?: InputMaybe<Array<GraphicInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** The level of the vendor. Must be one of: workspace_id, member_id, evaluation_id, evaluation_version_id. You can use evaluation_id:evaluation_version to send evaluation version level. */
  level?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<LinkInput>>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  modDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  pricingRules?: InputMaybe<Array<Scalars['String']['input']>>;
  recordTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  saveToOrg?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
  sourceType?: InputMaybe<Scalars['String']['input']>;
};

export type VendorsInput = {
  curationLevel?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['UUID']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  vendors: Array<VendorInput>;
};

export type Workspace = {
  __typename?: 'Workspace';
  billingCode?: Maybe<Scalars['String']['output']>;
  commonName: Scalars['String']['output'];
  creator?: Maybe<User>;
  creatorId: Scalars['String']['output'];
  evaluations?: Maybe<Array<Evaluation>>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  members?: Maybe<Array<WorkspaceMember>>;
  name: Scalars['String']['output'];
  orgName?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Organization>;
  parentId?: Maybe<Scalars['String']['output']>;
  showBillingCode: Scalars['Boolean']['output'];
};

export type WorkspaceInvite = {
  __typename?: 'WorkspaceInvite';
  action: Scalars['String']['output'];
  inviteToId: Scalars['String']['output'];
  inviteeEmail?: Maybe<Scalars['String']['output']>;
  inviteeId?: Maybe<Scalars['String']['output']>;
  invitorId?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  roles: Scalars['String']['output'];
};

/** Input to use toinvite one person to a workspace. */
export type WorkspaceInviteInput = {
  action?: Scalars['String']['input'];
  inviteToId: Scalars['String']['input'];
  inviteeEmail?: InputMaybe<Scalars['String']['input']>;
  inviteeId?: InputMaybe<Scalars['String']['input']>;
  invitorId?: InputMaybe<Scalars['String']['input']>;
  roles?: Scalars['String']['input'];
};

/** Input to use to invite more than one member to a workspace. */
export type WorkspaceInviteInputs = {
  invites: Array<WorkspaceInviteInput>;
};

export type WorkspaceMember = {
  __typename?: 'WorkspaceMember';
  id?: Maybe<Scalars['Int']['output']>;
  inviteStatus?: Maybe<Scalars['String']['output']>;
  memberId: Scalars['String']['output'];
  orgId?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['JSON']['output']>;
  roles?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  workspaceId: Scalars['String']['output'];
};

export type WorkspaceMetaDataInput = {
  commonName: Scalars['String']['input'];
  isDefault?: Scalars['Boolean']['input'];
  otherMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  workspaceType?: WorkspaceType;
};

export type WorkspaceSetupInput = {
  billingCode?: InputMaybe<Scalars['String']['input']>;
  commonName?: InputMaybe<Scalars['String']['input']>;
  defaultMemberPolicy?: InputMaybe<Scalars['String']['input']>;
  defaultPlanPolicy?: InputMaybe<Scalars['String']['input']>;
  orgName?: InputMaybe<Scalars['String']['input']>;
  otherSetup?: InputMaybe<Scalars['JSON']['input']>;
  showBillingCode?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceType?: WorkspaceType;
};

export type WorkspaceSummary = {
  __typename?: 'WorkspaceSummary';
  billingCode?: Maybe<Scalars['String']['output']>;
  commonName: Scalars['String']['output'];
  creatorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  members?: Maybe<Array<WorkspaceMember>>;
  name: Scalars['String']['output'];
  orgName?: Maybe<Scalars['String']['output']>;
  parentId: Scalars['String']['output'];
  showBillingCode: Scalars['Boolean']['output'];
};

export enum WorkspaceType {
  Enterprise = 'ENTERPRISE',
  Individual = 'INDIVIDUAL',
  Smb = 'SMB',
  Taloflow = 'TALOFLOW'
}

export type AppliedUserIdQueryVariables = Exact<{ [key: string]: never; }>;


export type AppliedUserIdQuery = { __typename?: 'Query', appliedUserId: string };

export type UpdateProfileMutationVariables = Exact<{
  profile: UserDataInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'UserProfile', firstName: string, lastName: string } };

export type SendResetPasswordEmailMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail: boolean };

export type GetClientSetupQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetClientSetupQuery = { __typename?: 'Query', getClientSetup: { __typename?: 'ClientSetup', orgName?: string | null, menus?: any | null, tabs?: any | null, tables?: any | null, reportSectionsTweaks?: any | null, setups: Array<{ __typename?: 'KeyValue', key: string, value: string }> } };

export type WorkspaceDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceDashboardQuery = { __typename?: 'Query', dashboard: { __typename?: 'Dashboard', owner?: { __typename?: 'User', memberId: any } | null, workspace?: { __typename?: 'WorkspaceSummary', id: string, name: string, parentId: string, creatorId: string, commonName: string, billingCode?: string | null, showBillingCode: boolean, orgName?: string | null, members?: Array<{ __typename?: 'WorkspaceMember', roles?: string | null, user?: { __typename?: 'User', memberId: any, profile?: { __typename?: 'UserProfile', email: string } | null } | null }> | null } | null } };

export type DashboardEvaluationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardEvaluationsQuery = { __typename?: 'Query', dashboard: { __typename?: 'Dashboard', owner?: { __typename?: 'User', memberId: any } | null, workspace?: { __typename?: 'WorkspaceSummary', id: string } | null, evaluations: Array<{ __typename?: 'DashboardEvaluation', id: any, name: string, versionNumber?: number | null, modDate: any, createDate: any, slug?: string | null, type: EvaluationType, workspace?: { __typename?: 'WorkspaceSummary', id: string, creatorId: string } | null, status?: Array<{ __typename?: 'KeyValue', key: string, value: string }> | null, collaborators?: Array<{ __typename?: 'Collaborator', id?: any | null, avatar?: string | null, name?: string | null, email?: string | null, allowPermissions?: Array<string> | null, roles?: Array<string> | null }> | null, owner: { __typename?: 'User', auth0Id?: string | null, name?: string | null, memberId: any, profile?: { __typename?: 'UserProfile', fullName: string, avatar: string, email: string } | null }, evaluationVersions?: Array<{ __typename?: 'EvaluationVersionSummary', id: any, evaluationId: any, versionNumber: number }> | null }> } };

export type WorkspacListQueryVariables = Exact<{
  memberID: Scalars['String']['input'];
}>;


export type WorkspacListQuery = { __typename?: 'Query', getWorkspacesForMember: Array<{ __typename?: 'Workspace', id: string, name: string, parentId?: string | null, creatorId: string, commonName: string, billingCode?: string | null, showBillingCode: boolean, orgName?: string | null }> };

export type ChangeDashboardMutationMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type ChangeDashboardMutationMutation = { __typename?: 'Mutation', changeDashboard: { __typename?: 'Dashboard', id: string } };

export type UserQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', auth0Id?: string | null, profile?: { __typename?: 'UserProfile', firstName: string, lastName: string, avatar: string, email: string, fullName: string } | null } };

export type MembersListQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type MembersListQuery = { __typename?: 'Query', getWorkspaceMembers: Array<{ __typename?: 'WorkspaceMember', memberId: string, orgId?: string | null, roles?: string | null, permissions?: any | null, inviteStatus?: string | null, user?: { __typename?: 'User', memberId: any, profile?: { __typename?: 'UserProfile', email: string, avatar: string, fullName: string } | null } | null }> };

export type InviteMemberToWorkspaceMutationVariables = Exact<{
  input: WorkspaceInviteInput;
}>;


export type InviteMemberToWorkspaceMutation = { __typename?: 'Mutation', inviteMemberToWorkspace: { __typename?: 'WorkspaceInvite', memberId?: string | null } };

export type InviteMembersToWorkspaceMutationVariables = Exact<{
  input: WorkspaceInviteInputs;
}>;


export type InviteMembersToWorkspaceMutation = { __typename?: 'Mutation', inviteMembersToWorkspace: Array<{ __typename?: 'WorkspaceInvite', memberId?: string | null }> };

export type CreateWorkspaceMutationMutationVariables = Exact<{
  input: CreateWorkspaceInput;
}>;


export type CreateWorkspaceMutationMutation = { __typename?: 'Mutation', createWorkspace: { __typename?: 'Workspace', id: string } };

export type UpdateWorkspaceMutationVariables = Exact<{
  input: CreateWorkspaceInput;
}>;


export type UpdateWorkspaceMutation = { __typename?: 'Mutation', updateWorkspace: { __typename?: 'Workspace', commonName: string, parentId?: string | null, billingCode?: string | null } };

export type UpdateEvaluationNameMutationMutationVariables = Exact<{
  evaluationId: Scalars['String']['input'];
  evaluationVersion: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateEvaluationNameMutationMutation = { __typename?: 'Mutation', updateEvaluationName: boolean };

export type UpsertChangeReasonMutationVariables = Exact<{
  input: UpsertChangeReasonInput;
}>;


export type UpsertChangeReasonMutation = { __typename?: 'Mutation', upsertChangeReason: { __typename?: 'ChangeReason', changeId: any, changorId: string, changorType: string, location?: string | null, reason: string, reasonBind?: string | null, source: string } };

export type DownloadReportPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadReportPermissionQuery = { __typename?: 'Query', canDownloadReport: boolean };

export type DownloadDetailSpreadsheetBytesQueryVariables = Exact<{
  evaluationId: Scalars['ID']['input'];
}>;


export type DownloadDetailSpreadsheetBytesQuery = { __typename?: 'Query', getDetailSpreadsheetBytes: string };

export type EvaluationVersionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EvaluationVersionQuery = { __typename?: 'Query', evaluation: { __typename?: 'Evaluation', id: any, name: string, slug?: string | null, modDate: any, versionNumber?: number | null, collaborators?: Array<{ __typename?: 'Collaborator', id?: any | null, email?: string | null, roles?: Array<string> | null }> | null } };

export type EvaluationVersionClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EvaluationVersionClientQuery = { __typename?: 'Query', evaluation: { __typename?: 'Evaluation', id: any, name: string, slug?: string | null, modDate: any, versionNumber?: number | null, collaborators?: Array<{ __typename?: 'Collaborator', id?: any | null, avatar?: string | null, name?: string | null, email?: string | null, roles?: Array<string> | null, allowPermissions?: Array<string> | null, status?: CollaboratorStatus | null }> | null, status?: Array<{ __typename?: 'KeyValue', key: string, value: string }> | null, evaluationVersions?: Array<{ __typename?: 'EvaluationVersionSummary', id: any, evaluationId: any, versionNumber: number }> | null, workspace?: { __typename?: 'Workspace', id: string } | null, owner: { __typename?: 'User', memberId: any } } };

export type EvaluationPageDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type EvaluationPageDashboardQuery = { __typename?: 'Query', dashboard: { __typename?: 'Dashboard', workspace?: { __typename?: 'WorkspaceSummary', id: string } | null } };

export type CreateEvaluationMutationVariables = Exact<{
  input: EvaluationInput;
}>;


export type CreateEvaluationMutation = { __typename?: 'Mutation', createEvaluation: { __typename?: 'CreateEvaluationSimpleResponse', evaluationVersionId: string, sectionName?: string | null } };

export type CreateEvaluationProductsQueryVariables = Exact<{
  level?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateEvaluationProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'BindRef', value: string, label: string, key: string }> };

export type CreateEvaluationProductCategoriesQueryVariables = Exact<{
  level?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEvaluationProductCategoriesQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategory', id: string, key: string, label: string, value: string, subtext?: string | null, type?: string | null, lastReviewDate?: string | null }> };

export type EvaluationUseCaseQueryQueryVariables = Exact<{
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type EvaluationUseCaseQueryQuery = { __typename?: 'Query', useCases: Array<{ __typename?: 'UseCaseMetaDataDetail', id: string, name: string, isPrimary?: boolean | null, shortDescription?: string | null, longDescription?: string | null, aliases: Array<{ __typename?: 'Alias', name: string }> }> };

export type GetEvaluationBySessionQueryVariables = Exact<{
  stripeSession: Scalars['String']['input'];
}>;


export type GetEvaluationBySessionQuery = { __typename?: 'Query', evaluationByStripeSession: { __typename?: 'Evaluation', id: any, setups?: Array<{ __typename?: 'KeyValue', key: string, value: string }> | null } };

export type AtomicRefTooltipProductQueryQueryVariables = Exact<{
  referenceId: Scalars['ID']['input'];
}>;


export type AtomicRefTooltipProductQueryQuery = { __typename?: 'Query', getProductUi: { __typename?: 'UiProduct', name: string, shortDescription?: string | null } };

export type AtomicRefTooltipVendorQueryQueryVariables = Exact<{
  referenceId: Scalars['ID']['input'];
}>;


export type AtomicRefTooltipVendorQueryQuery = { __typename?: 'Query', getVendorUi: { __typename?: 'UiVendor', name: string, shortDescription?: string | null } };

export type FeaturesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filterIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FeaturesQuery = { __typename?: 'Query', features: Array<{ __typename?: 'BindRef', key: string, bind: string, label: string, value: string }> };

export type DimensionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filterIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DimensionsQuery = { __typename?: 'Query', dimensions: Array<{ __typename?: 'BindRef', key: string, label: string, bind: string, value: string }> };

export type RequirementsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filterIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RequirementsQuery = { __typename?: 'Query', requirements: Array<{ __typename?: 'BindRef', key: string, label: string, bind: string, value: string }> };

export type ProductsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'BindRef', key: string, label: string, bind: string, value: string }> };

export type VendorsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VendorsQuery = { __typename?: 'Query', vendors: Array<{ __typename?: 'BindRef', bind: string, key: string, label: string, text?: string | null, value: string }> };

export type ComparisonTableQueryVariables = Exact<{
  firstProductId: Scalars['String']['input'];
  secondProductId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  evaluationId: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type ComparisonTableQuery = { __typename?: 'Query', getComparisonTable: { __typename?: 'BindRef', bind: string, key: string, label: string, text?: string | null, value: string } };

export type CarouselItemFragment = { __typename?: 'CarouselCard', id: string, icon?: CarouselCardIcon | null, color: string, title: string, body: string, action: { __typename: 'CarouselLinkAction', type: CarouselCardActionType, url: string, label: string } } & { ' $fragmentName'?: 'CarouselItemFragment' };

export type UpsertDimensionMutationVariables = Exact<{
  input: DimensionUpsertInput;
}>;


export type UpsertDimensionMutation = { __typename?: 'Mutation', upsertDimension: { __typename?: 'Refid', id: string } };

export type UpsertFeatureMutationVariables = Exact<{
  input: ProductFeatureUpsertInput;
}>;


export type UpsertFeatureMutation = { __typename?: 'Mutation', upsertFeature: { __typename?: 'Refid', id: string } };

export type UpsertProductMutationVariables = Exact<{
  input: ProductInput;
}>;


export type UpsertProductMutation = { __typename?: 'Mutation', upsertProduct: { __typename?: 'Product', id: any } };

export type UpsertRequirementMutationVariables = Exact<{
  input: RequirementUpsertInput;
}>;


export type UpsertRequirementMutation = { __typename?: 'Mutation', upsertRequirement: { __typename?: 'Refid', id: string } };

export type ExcludeProductMutationVariables = Exact<{
  input: EvaluationExcludeProductInput;
}>;


export type ExcludeProductMutation = { __typename?: 'Mutation', excludeProduct: boolean };

export type DeleteRequirementMutationVariables = Exact<{
  level: Scalars['ID']['input'];
  refId: Scalars['ID']['input'];
}>;


export type DeleteRequirementMutation = { __typename?: 'Mutation', deleteRequirement: boolean };

export type DeleteDimensionMutationVariables = Exact<{
  level: Scalars['ID']['input'];
  refId: Scalars['ID']['input'];
}>;


export type DeleteDimensionMutation = { __typename?: 'Mutation', deleteDimension: boolean };

export type DeleteFeatureMutationVariables = Exact<{
  level: Scalars['ID']['input'];
  refId: Scalars['ID']['input'];
}>;


export type DeleteFeatureMutation = { __typename?: 'Mutation', deleteFeature: boolean };

export type ChangeEvaluationStatusMutationVariables = Exact<{
  evaluationId: Scalars['String']['input'];
  newStatus: Scalars['String']['input'];
}>;


export type ChangeEvaluationStatusMutation = { __typename?: 'Mutation', changeEvaluationStatus: boolean };

export type CreateEvaluation_EvaluationFragment = { __typename?: 'Evaluation', id: any, name: string, slug?: string | null, modDate: any, createDate: any, versionNumber?: number | null, type: EvaluationType, owner: { __typename?: 'User', auth0Id?: string | null, name?: string | null, memberId: any, profile?: { __typename?: 'UserProfile', avatar: string } | null }, collaborators?: Array<{ __typename?: 'Collaborator', id?: any | null, avatar?: string | null, name?: string | null, email?: string | null, roles?: Array<string> | null, allowPermissions?: Array<string> | null }> | null, status?: Array<{ __typename?: 'KeyValue', key: string, value: string }> | null, evaluationVersions?: Array<{ __typename?: 'EvaluationVersionSummary', id: any, evaluationId: any, versionNumber: number }> | null, workspace?: { __typename?: 'Workspace', id: string, creatorId: string } | null } & { ' $fragmentName'?: 'CreateEvaluation_EvaluationFragment' };

export type CreateEvaluationVersionMutationMutationVariables = Exact<{
  input: EvaluationVersionInput;
}>;


export type CreateEvaluationVersionMutationMutation = { __typename?: 'Mutation', createEvaluationVersion: { __typename?: 'CreateEvaluationResponse', sectionName?: string | null, evaluation: (
      { __typename?: 'Evaluation' }
      & { ' $fragmentRefs'?: { 'CreateEvaluation_EvaluationFragment': CreateEvaluation_EvaluationFragment } }
    ) } };

export type GetCollaboratorsQueryVariables = Exact<{
  evaluationId: Scalars['ID']['input'];
}>;


export type GetCollaboratorsQuery = { __typename?: 'Query', collaborators: Array<{ __typename?: 'Collaborator', id?: any | null, roles?: Array<string> | null, name?: string | null, avatar?: string | null, email?: string | null, status?: CollaboratorStatus | null, allowPermissions?: Array<string> | null }> };

export type AddCollaboratorsMutationVariables = Exact<{
  input: EvaluationInviteInputs;
}>;


export type AddCollaboratorsMutation = { __typename?: 'Mutation', processInviteToEvaluations: Array<{ __typename?: 'EvaluationInvite', inviteeEmail?: string | null }> };

export type MultiSelectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
}>;


export type MultiSelectQuery = { __typename?: 'Query', multiSelect: Array<{ __typename?: 'BindRef', bind: string, value: string, label: string }> };

export const CarouselItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarouselItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CarouselCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CarouselLinkAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<CarouselItemFragment, unknown>;
export const CreateEvaluation_EvaluationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateEvaluation_Evaluation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Evaluation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"modDate"}},{"kind":"Field","name":{"kind":"Name","value":"createDate"}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth0Id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"allowPermissions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluationVersions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluationId"}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creatorId"}}]}}]}}]} as unknown as DocumentNode<CreateEvaluation_EvaluationFragment, unknown>;
export const AppliedUserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppliedUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliedUserId"}}]}}]} as unknown as DocumentNode<AppliedUserIdQuery, AppliedUserIdQueryVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const SendResetPasswordEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendResetPasswordEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendResetPasswordEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}]}}]} as unknown as DocumentNode<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const GetClientSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getClientSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgName"}},{"kind":"Field","name":{"kind":"Name","value":"menus"}},{"kind":"Field","name":{"kind":"Name","value":"tabs"}},{"kind":"Field","name":{"kind":"Name","value":"tables"}},{"kind":"Field","name":{"kind":"Name","value":"reportSectionsTweaks"}},{"kind":"Field","name":{"kind":"Name","value":"setups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetClientSetupQuery, GetClientSetupQueryVariables>;
export const WorkspaceDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"creatorId"}},{"kind":"Field","name":{"kind":"Name","value":"commonName"}},{"kind":"Field","name":{"kind":"Name","value":"billingCode"}},{"kind":"Field","name":{"kind":"Name","value":"showBillingCode"}},{"kind":"Field","name":{"kind":"Name","value":"orgName"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkspaceDashboardQuery, WorkspaceDashboardQueryVariables>;
export const DashboardEvaluationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardEvaluations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creatorId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"modDate"}},{"kind":"Field","name":{"kind":"Name","value":"createDate"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"allowPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth0Id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluationVersions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluationId"}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardEvaluationsQuery, DashboardEvaluationsQueryVariables>;
export const WorkspacListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspacList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWorkspacesForMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"creatorId"}},{"kind":"Field","name":{"kind":"Name","value":"commonName"}},{"kind":"Field","name":{"kind":"Name","value":"billingCode"}},{"kind":"Field","name":{"kind":"Name","value":"showBillingCode"}},{"kind":"Field","name":{"kind":"Name","value":"orgName"}}]}}]}}]} as unknown as DocumentNode<WorkspacListQuery, WorkspacListQueryVariables>;
export const ChangeDashboardMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeDashboardMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangeDashboardMutationMutation, ChangeDashboardMutationMutationVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"User"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth0Id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const MembersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MembersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWorkspaceMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"orgId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"inviteStatus"}}]}}]}}]} as unknown as DocumentNode<MembersListQuery, MembersListQueryVariables>;
export const InviteMemberToWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteMemberToWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkspaceInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteMemberToWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}}]}}]}}]} as unknown as DocumentNode<InviteMemberToWorkspaceMutation, InviteMemberToWorkspaceMutationVariables>;
export const InviteMembersToWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteMembersToWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkspaceInviteInputs"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteMembersToWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}}]}}]}}]} as unknown as DocumentNode<InviteMembersToWorkspaceMutation, InviteMembersToWorkspaceMutationVariables>;
export const CreateWorkspaceMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWorkspaceMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkspaceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateWorkspaceMutationMutation, CreateWorkspaceMutationMutationVariables>;
export const UpdateWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkspaceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commonName"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"billingCode"}}]}}]}}]} as unknown as DocumentNode<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>;
export const UpdateEvaluationNameMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEvaluationNameMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evaluationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evaluationVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEvaluationName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"evaluationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evaluationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"evaluationVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evaluationVersion"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}]}}]} as unknown as DocumentNode<UpdateEvaluationNameMutationMutation, UpdateEvaluationNameMutationMutationVariables>;
export const UpsertChangeReasonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertChangeReason"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertChangeReasonInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertChangeReason"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeId"}},{"kind":"Field","name":{"kind":"Name","value":"changorId"}},{"kind":"Field","name":{"kind":"Name","value":"changorType"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"reasonBind"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<UpsertChangeReasonMutation, UpsertChangeReasonMutationVariables>;
export const DownloadReportPermissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadReportPermission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDownloadReport"}}]}}]} as unknown as DocumentNode<DownloadReportPermissionQuery, DownloadReportPermissionQueryVariables>;
export const DownloadDetailSpreadsheetBytesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadDetailSpreadsheetBytes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evaluationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDetailSpreadsheetBytes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"evaluationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evaluationId"}}}]}]}}]} as unknown as DocumentNode<DownloadDetailSpreadsheetBytesQuery, DownloadDetailSpreadsheetBytesQueryVariables>;
export const EvaluationVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EvaluationVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"evaluation"},"name":{"kind":"Name","value":"evaluationVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"modDate"}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}}]}}]}}]} as unknown as DocumentNode<EvaluationVersionQuery, EvaluationVersionQueryVariables>;
export const EvaluationVersionClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EvaluationVersionClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"evaluation"},"name":{"kind":"Name","value":"evaluationVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"modDate"}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"allowPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluationVersions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluationId"}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberId"}}]}}]}}]}}]} as unknown as DocumentNode<EvaluationVersionClientQuery, EvaluationVersionClientQueryVariables>;
export const EvaluationPageDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EvaluationPageDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EvaluationPageDashboardQuery, EvaluationPageDashboardQueryVariables>;
export const CreateEvaluationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEvaluation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EvaluationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEvaluation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evaluationVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}}]}}]}}]} as unknown as DocumentNode<CreateEvaluationMutation, CreateEvaluationMutationVariables>;
export const CreateEvaluationProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateEvaluationProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"level"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"products"},"name":{"kind":"Name","value":"getProductsBindref"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"level"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode<CreateEvaluationProductsQuery, CreateEvaluationProductsQueryVariables>;
export const CreateEvaluationProductCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateEvaluationProductCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"level"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"level"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"subtext"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lastReviewDate"}}]}}]}}]} as unknown as DocumentNode<CreateEvaluationProductCategoriesQuery, CreateEvaluationProductCategoriesQueryVariables>;
export const EvaluationUseCaseQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EvaluationUseCaseQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productCategoryName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"useCases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productCategoryName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productCategoryName"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"longDescription"}},{"kind":"Field","name":{"kind":"Name","value":"aliases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<EvaluationUseCaseQueryQuery, EvaluationUseCaseQueryQueryVariables>;
export const GetEvaluationBySessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEvaluationBySession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripeSession"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evaluationByStripeSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stripeSession"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripeSession"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"setups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetEvaluationBySessionQuery, GetEvaluationBySessionQueryVariables>;
export const AtomicRefTooltipProductQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AtomicRefTooltipProductQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductUi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}}]}}]} as unknown as DocumentNode<AtomicRefTooltipProductQueryQuery, AtomicRefTooltipProductQueryQueryVariables>;
export const AtomicRefTooltipVendorQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AtomicRefTooltipVendorQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVendorUi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}}]}}]} as unknown as DocumentNode<AtomicRefTooltipVendorQueryQuery, AtomicRefTooltipVendorQueryQueryVariables>;
export const FeaturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Features"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"features"},"name":{"kind":"Name","value":"getFeatures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"bind"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FeaturesQuery, FeaturesQueryVariables>;
export const DimensionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Dimensions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dimensions"},"name":{"kind":"Name","value":"getDimensions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"bind"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<DimensionsQuery, DimensionsQueryVariables>;
export const RequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Requirements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"requirements"},"name":{"kind":"Name","value":"getRequirements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"bind"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<RequirementsQuery, RequirementsQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAll"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"products"},"name":{"kind":"Name","value":"getProductsBindref"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAll"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"bind"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const VendorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Vendors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"vendors"},"name":{"kind":"Name","value":"getVendorsBindref"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bind"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<VendorsQuery, VendorsQueryVariables>;
export const ComparisonTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComparisonTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstProductId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"secondProductId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evaluationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getComparisonTable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstProductId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstProductId"}}},{"kind":"Argument","name":{"kind":"Name","value":"secondProductId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"secondProductId"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"evaluationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evaluationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bind"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ComparisonTableQuery, ComparisonTableQueryVariables>;
export const UpsertDimensionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertDimension"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DimensionUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertDimension"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertDimensionMutation, UpsertDimensionMutationVariables>;
export const UpsertFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductFeatureUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertFeatureMutation, UpsertFeatureMutationVariables>;
export const UpsertProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertProductMutation, UpsertProductMutationVariables>;
export const UpsertRequirementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertRequirement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertRequirement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertRequirementMutation, UpsertRequirementMutationVariables>;
export const ExcludeProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExcludeProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EvaluationExcludeProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"excludeProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ExcludeProductMutation, ExcludeProductMutationVariables>;
export const DeleteRequirementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRequirement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"level"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRequirement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"level"}}},{"kind":"Argument","name":{"kind":"Name","value":"refId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refId"}}}]}]}}]} as unknown as DocumentNode<DeleteRequirementMutation, DeleteRequirementMutationVariables>;
export const DeleteDimensionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDimension"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"level"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDimension"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"level"}}},{"kind":"Argument","name":{"kind":"Name","value":"refId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refId"}}}]}]}}]} as unknown as DocumentNode<DeleteDimensionMutation, DeleteDimensionMutationVariables>;
export const DeleteFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"level"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"level"}}},{"kind":"Argument","name":{"kind":"Name","value":"refId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refId"}}}]}]}}]} as unknown as DocumentNode<DeleteFeatureMutation, DeleteFeatureMutationVariables>;
export const ChangeEvaluationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeEvaluationStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evaluationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeEvaluationStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"evaluationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evaluationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newStatus"}}}]}]}}]} as unknown as DocumentNode<ChangeEvaluationStatusMutation, ChangeEvaluationStatusMutationVariables>;
export const CreateEvaluationVersionMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEvaluationVersionMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EvaluationVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEvaluationVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evaluation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateEvaluation_Evaluation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateEvaluation_Evaluation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Evaluation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"modDate"}},{"kind":"Field","name":{"kind":"Name","value":"createDate"}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth0Id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"allowPermissions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluationVersions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluationId"}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creatorId"}}]}}]}}]} as unknown as DocumentNode<CreateEvaluationVersionMutationMutation, CreateEvaluationVersionMutationMutationVariables>;
export const GetCollaboratorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollaborators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evaluationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collaborators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"evaluationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evaluationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"allowPermissions"}}]}}]}}]} as unknown as DocumentNode<GetCollaboratorsQuery, GetCollaboratorsQueryVariables>;
export const AddCollaboratorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddCollaborators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EvaluationInviteInputs"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processInviteToEvaluations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteeEmail"}}]}}]}}]} as unknown as DocumentNode<AddCollaboratorsMutation, AddCollaboratorsMutationVariables>;
export const MultiSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MultiSelect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiSelect"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"evaluationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bind"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<MultiSelectQuery, MultiSelectQueryVariables>;